
import {
  defineComponent, onActivated, reactive, ref, toRaw,
} from 'vue';
import { TreeDataItem } from 'ant-design-vue/es/tree/Tree';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import {
  getAllRole, getPermissionsRoleByRoleId, insertPermissionRole, saveOrUpdatePermission, deletePermission,
} from '@/request/view/menu';
import MenuManager, { routerArr as baseRoute } from '@/utils/base/getMenu';
import { getPermissionTree, getPermissionsByUserId, insertPermissionUser } from '@/request/view/permissions';
import {
  requestList, requestDelete,
} from '@/utils/rule/request';
import transerStructure from '@/utils/base/transerStructure';
import customButton from '@/components/button/common.vue';
import { notice, setData } from '@/utils';
import { ModalToast, ModalParams } from '@/utils/modalToast';
import TreeNode from './compoments/tree.vue';
import afterSale from './compoments/afterSale.vue';
import treeAuthority from './tree/index.vue';
import filterMenu from '@/views/menu/compoments/filterMenu.vue';

export default defineComponent({
  components: {
    customButton, TreeNode, afterSale, treeAuthority, filterMenu
  },
  setup() {
    const useName = {
      delete: '删除',
      add: '添加',
      edit: '编辑',
      look: '查看',
    };

    const saveConfigDisabled = ref(true);

    const isDevelopment = process.env.NODE_ENV === 'development';

    const filterMenuRef = ref();

    const afterSalePerson = ref();
    const point = reactive({});
    const routes = useRoute();
    const editForm = reactive({
      id: undefined,
      roleName: undefined,
      type: undefined,
    });
    const loadTree = ref(true);
    const store = useStore();
    const currentRoleId = store.state.user.user.roleId;
    const menuManager = new MenuManager(currentRoleId);
    // 权限
    const userSelectMenu = ref([]);
    const active = ref(undefined);
    let roleId = '';
    let rolePermission = [];
    // 菜单&角色
    const treeData: TreeDataItem[] = reactive([]);
    const roleTreeData: TreeDataItem[] = reactive([]);

    const formRef = ref();
    const roleformRef = ref();
    // 添加/修改菜单的对象
    const formState = reactive({
      routeUrl: undefined,
      remarks: undefined,
      icon: undefined,
      name: undefined,
      identify: undefined,
      pid: 0,
      id: '',
      type: '1',
      sort: '',
    });
    // 添加/修改权限的对象
    const uploadPermission = {
      pid: 0,
      name: '',
      identify: '',
      remarks: '',
      type: 2,
      id: undefined,
      sort: '',
    };
    const permissionButton = ref([]);
    const roleFormState = reactive({
      type: undefined,
      roleName: undefined,
    });
    const routerArr = baseRoute;
    function getAllMenu(routeList) {
      const list = [];
      routeList.forEach((item) => {
        list.push(item);
        if (item.children && item.children.length > 0) {
          list.push(...getAllMenu(item.children));
        }
      });
      return list;
    }
    const allList = getAllMenu(routerArr);
    const meneOptions = ref([]);
    const replaceFields = {
      label: 'meta.title',
      value: 'path',
    };
    const replacekey = {
      key: 'id',
    };
    const setMeneValue = (arr) => {
      const newarr = arr.filter((item) => item.meta.type === 'page');
      console.log(newarr);

      meneOptions.value.length = 0;
      meneOptions.value = transerStructure(newarr, replaceFields, true);
    };

    const checkrouteUrl = async () => {
      if (formState.identify === undefined) {
        return Promise.reject(new Error('请选择菜单'));
      }
      return Promise.resolve();
    };
    const checkSort = async () => {
      if (formState.sort === undefined || formState.sort === '') {
        return Promise.reject(new Error('请输入排序'));
      }
      return Promise.resolve();
    };
    const checkType = async () => {
      if (roleFormState.type === undefined || roleFormState.type === '') {
        return Promise.reject(new Error('请选择角色类型'));
      }
      return Promise.resolve();
    };
    const checkpermissions = async () => {
      if (permissionButton.value === undefined || permissionButton.value.length === 0) {
        return Promise.reject(new Error('请选择权限'));
      }
      return Promise.resolve();
    };
    // const checkIcon = async () => {
    //   if (formState.icon === undefined) {
    //     return Promise.reject(new Error('请选择图标'));
    //   }
    //   return Promise.resolve();
    // };
    const rules = {
      routeUrl: [{ required: true, validator: checkrouteUrl, trigger: 'change' }],
      sort: [{ required: true, validator: checkSort, trigger: 'blur' }],
      permissions: [{ required: true, validator: checkpermissions, trigger: 'blur' }],
      name: [{ required: true, message: '请输入菜单名称', trigger: 'blur' }],
    };

    const modalConfig = reactive({
      visible: false,
      title: '添加菜单',
      okText: '确定',
      cancelText: '取消',
      centered: true,
    });

    const iconModal = reactive({
      visible: false,
      title: '选择图标',
    });
    // 权限的方法
    function checkMenuOrPerssion(list: any) {
      list.forEach((item :any) => {
        if (item.type === '1') {
          item.slots = { title: 'custom' };
        } else if (item.type === '2') {
          item.slots = { title: 'cud' };
        }
        return item.children && item.children.length > 0 ? checkMenuOrPerssion(item.children) : false;
      });
    }
    const getPoint = (arr: TreeDataItem) => {
      arr.forEach((menu) => {
        menu.active = false;
        point[menu.id] = menu;
        if (menu.children && menu.children.length > 0) {
          getPoint(menu.children);
        }
      });
    };

    const deepSort = (sortlist) => {
      const list = sortlist.sort((a, b) => a.sort - b.sort);
      list.forEach((item) => {
        if (item.children && item.children.length > 0) {
          item.children = deepSort(item.children);
        }
      });
      return list;
    };

    const getPermissionList = async () => {
      let permissionlist = null;
      await getPermissionsByUserId({ userId: store.state.user.user.id }).then((res: any) =>{
        permissionlist = res.data
      });

      if (!permissionlist) return;
      const filterListFn = (list) => {
        const filterList = list.filter((item) => {
          if (item.children.length > 0) {
            item.children = filterListFn(item.children);
          }
          return permissionlist.findIndex((id) => item.id === id) !== -1;
        });
        return filterList;
      };

      getPermissionTree().then((res: any) => {
        const filterList = filterListFn(res.data);
        treeData.length = 0;
        if (requestList(res)) {
          const newList = deepSort(filterList);
          checkMenuOrPerssion(newList);
          treeData.push(...newList);
          getPoint(treeData);
        }
      });
    }

    // function getRoleData() {
    //   getAllRole().then((res: any) => {
    //     if (requestList(res)) {
    //       roleTreeData.length = 0;
    //       res.data.forEach((item) => {
    //         item.slots = { title: 'custom' };
    //       });
    //       roleTreeData.push(...res.data);
    //     }
    //   });
    // }

    function selectMenu(e) {
      console.log(userSelectMenu, '这是什么');
    }
    const selectRoleTree = (events, index) => {
      const role = events;
      editForm.roleName = role.roleName;
      editForm.id = role.id;
      editForm.type = role.type;

      // 新的方法
      active.value = index;
      roleId = role.id;
      loadTree.value = false;
      getPermissionsRoleByRoleId({ roleId: role.id }).then((res:any) => {
        try {
          Object.keys(point).forEach((key) => {
            point[key].active = false;
          });
          res.data.forEach((item) => {
            point[item].active = true;
          });

          rolePermission = res.data;
          userSelectMenu.value.length = 0;
          userSelectMenu.value.push(...res.data);
          loadTree.value = true;
        } catch (error) {
          
        }
      }).catch((error) => {
        loadTree.value = true;
      });
    };

    // 唤起添加权限表单
    const addPerssionById = (params) => {
      console.log(params, '我触发了');
      setData(params, formState, false);
      modalConfig.title = '权限配置';
      modalConfig.visible = true;
    };

    // 唤起添加菜单表单
    const addMenuById = (type, params) => {
      if (type === 'firstLevel') {
        setMeneValue(routerArr);
        formState.pid = 0;
        uploadPermission.pid = 0;
      } else {
        const [childMenu] = allList.filter((route) => route.path === params.identify);
        setMeneValue(childMenu.children);
        formState.pid = params.id;
      }
      modalConfig.title = '添加菜单';
      modalConfig.visible = true;
    };

    function toEdit(item) {
      modalConfig.title = '修改菜单信息';
      setData(item, formState, false);

      modalConfig.visible = true;
    }
    function closeMenuModal() {
      modalConfig.visible = false;
    }
    function deletePermissions(id) {
      // const { id } = permission.find((item) => item.identify === routeUrl);
      deletePermission({ query: { name: 'id', arr: [id] } }).then((res :any) => {
        if (requestDelete(res)) {
          notice('success', '提示', '删除成功', 3);
        } else if (res.code === 400) {
          notice('error', '提示', res.message, 3);
        }
        getPermissionList();
      }).catch((err) => {
        notice('error', '提示', '删除权限失败', 3);
      });
    }
    function toDelete(params) {
      const content = params.name;
      const modaloptions :ModalParams = {
        title: '提示',
        content: `确定删除${content}吗？`,
        cancelText: '取消',
        okText: '确定',
        centered: true,
        okType: 'primary',
      };
      ModalToast(modaloptions).then(() => {
        deletePermissions(params.id);
      }).catch((e) => {
        if (e.message === 'cancel') {
          notice('info', '提示', '取消删除', 3);
        }
      });
    }

    function toDeletePerssion(recode) {
      const modaloptions :ModalParams = {
        title: '提示',
        content: '确定要删除吗？',
        cancelText: '取消',
        okText: '确定',
        centered: true,
        okType: 'primary',
      };
      ModalToast(modaloptions).then(() => {
        deletePermission({ query: { name: 'id', arr: [recode.id] } }).then((res :any) => {
          if (res.code === 200 && res.message === '删除成功') {
            notice('success', '提示', '删除成功', 3);
          } else if (res.code === 400) {
            notice('error', '提示', res.message, 3);
          }
          getPermissionList();
        });
      }).catch((e) => {
        if (e.message === 'cancel') {
          notice('info', '提示', '取消删除', 3);
        }
      });
    }

    function toChooseIcon() {
      iconModal.visible = true;
    }
    function iconClose() {
      iconModal.visible = false;
    }
    function iconSelect(e) {
      iconModal.visible = false;
      formState.icon = e.value.name;
    }
    function removeIcon() {
      formState.icon = undefined;
    }
    function reSetForm() {
      formRef.value.resetFields();
      Object.keys(formState).forEach((key) => {
        formState[key] = undefined;
      });
      permissionButton.value.length = 0;
    }
    function reSetRoleForm() {
      roleformRef.value.resetFields();
      setData({}, roleFormState, true);
    }
    function handleClose() {
      console.log('触发了关闭事件');
      if (modalConfig.title === '权限配置') {
        // if (permissionButton.value !== undefined) {
        permissionButton.value.length = 0;
        // }
        formRef.value.clearValidate('permissions');
      }
      Object.keys(formState).forEach((key) => {
        formState[key] = undefined;
      });
      formRef.value.resetFields();
      console.log(formState, '清除后表单的数据是');
    }

    // 重置数据
    function resetMenelist() {
      reSetForm();
      // getMenuData();
      getPermissionList();
      selectRoleTree(editForm, active.value);
    }

    // 添加权限
    function addPerssion() {
      uploadPermission.identify = formState.routeUrl;
      saveOrUpdatePermission(formState).then((res: any) => {
        if (res.message === '添加权限菜单成功' && res.code === 200) {
          notice('success', '提示', '添加菜单成功', 3);
        } else if (res.message === '更新权限菜单成功' && res.code === 200) {
          notice('success', '提示', '更新菜单信息成功', 3);
        } else if (res.code === 400) {
          notice('error', '提示', res.message, 3);
        } else {
          notice('error', '提示', '添加菜单失败', 3);
        }
        closeMenuModal();
        resetMenelist();
        // getPermissionList();
      }).catch((err) => {
        notice('error', '提示', '添加权限失败', 3);
      });
    }
    // 给页面配置权限
    function setPerssionForPage() {
      const indexSort = {
        look: 0,
        add: 1,
        edit: 2,
        delete: 3,
      };
      const promiseArr = [];
      const obj = uploadPermission;
      obj.type = 2;
      // const { id } = permission.find((item) => item.identify === formState.routeUrl);
      obj.pid = Number(formState.id);
      permissionButton.value.forEach((item) => {
        const p = new Promise((resolve, reject) => {
          obj.identify = `${formState.identify}_${item}`;
          obj.name = item;
          obj.sort = indexSort[item];
          saveOrUpdatePermission(uploadPermission).then((res) => {
            resolve(res);
          }).catch((err) => {
            reject(err);
          });
        });
        promiseArr.push(p);
      });
      Promise.all(promiseArr).then((res) => {
        if (res && res.length > 0) {
          res.forEach((item) => {
            if (item.code === 200) {
              notice('success', '提示', res[0].message, 3);
            } else {
              notice('warning', '提示', res[0].message, 3);
            }
          });
        }

        resetMenelist();
        closeMenuModal();
      }).catch((err) => {
        notice('error', '提示', '配置权限失败', 3);
        resetMenelist();
        closeMenuModal();
      });
    }
    // 添加菜单确定
    function handleOk() {
      formRef.value.validate().then(() => {
        if (modalConfig.title === '权限配置') {
          setPerssionForPage();
        } else if (modalConfig.title === '添加菜单') {
          const nameIndex = meneOptions.value.findIndex((item) => item.value === formState.identify);
          formState.name = nameIndex === -1 ? formState.name : meneOptions.value[nameIndex].label;
          // addMenu();
          addPerssion();
        } else if (modalConfig.title === '修改菜单信息') {
          addPerssion();
        }
      }).catch((err) => {
        // if (verifyErrorToast(err)) {
        //   notice('error', '提示', err.errorFields[0].errors, 3);
        // }
      });
    }

    // 保存配置
    const saveConfig = () => {
      const arr = [];
      Object.keys(point).forEach((key) => {
        if (point[key].active) {
          arr.push(point[key].id);
        }
      });
      insertPermissionUser({ userId: roleId }, arr).then((res: any) => {
        console.log(res);
        if (res.code === 200 && res.message === '权限添加成功') {
          notice('success', '提示', '修改权限成功', 3);
        } else if (res.code === 400) {
          notice('error', '提示', res.message, 3);
        }
        if (currentRoleId === roleId) {
          menuManager.findRoute();
        }
      }).catch((err) => {
        console.log(err);
      });
    };

    function init() {
      // getMenuData();
      getPermissionList();
      // getRoleData();
      setMeneValue(routerArr);
    }

    function checkMenuChild(e) {
      if (e.identify === '/school') {
        return false;
      }
      const cutInfo = e;
      const node = allList.find((item) => item.path === cutInfo.identify);
      return !!(node && node.children);
    }

    // 全选反选
    const setChildActive = (arr: TreeDataItem, type: boolean) => {
      arr.forEach((item) => {
        item.active = type;
        if (item.children && item.children.length > 0) {
          setChildActive(item.children, type);
        }
      });
    };

    const selectAuthority = (item) => {
      if (item.children && item.children.length > 0) {
        setChildActive(item.children, item.active);
        if (item.active) {
          item.indeterminate = false;
        }
      }
    };

    //  检测父的全选反选
    // const setSuperiorActive = () => {

    // };

    const checkSuperior = (item) => {
      setTimeout(() => {
        const useActive = item.active;
        const superiorPid = item.pid;
        const superior = point[superiorPid];
        try {
          if (superior.children && superior.children.length > 0) {
            if (superior.pid !== 0) {
              checkSuperior(superior);
            }
            superior.children.forEach((child) => {
              if (child.active !== useActive) {
                superior.indeterminate = true;
                throw (new Error('loop over'));
              }
            });
            superior.active = useActive;
            superior.indeterminate = false;
            console.log(useActive);
          }
        } catch (error) {
          superior.active = false;
          console.log(error, superior);
        }
      }, 0);
    };
    const selectUser = (user) => {
      loadTree.value = false;
      if (user === null) {
        saveConfigDisabled.value = true;
        return;
      }
      if (roleId === user.id) return;
      roleId = user.id;
      getPermissionsByUserId({
        userId: user.id,
      }).then((res) => {
        saveConfigDisabled.value = false;
        try {
          Object.keys(point).forEach((key) => {
            point[key].active = false;
          });
          res.data.forEach((item) => {
            if (point[item]) {
              point[item].active = true;
            }
          });
          rolePermission = res.data;
          userSelectMenu.value.length = 0;
          userSelectMenu.value.push(...res.data);
          loadTree.value = true;

        } catch (error) {
          console.log(error)
        }
      }).catch((error) => {
        loadTree.value = true;
      });
    };

    const handleUpdateMenu = () => {
      filterMenuRef.value.showModal()
    };

    // onActivated(() => {
    //   if (routes.query.fromOrigin === 'menu') {
    //     roleId = null;
    //     init();
    //   }
    // });
    init();
    return {
      // 页面中编辑的用户信息
      editForm,
      afterSalePerson,
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      saveConfigDisabled,
      rules,
      point,
      useName,
      formRef,
      loadTree,
      active,
      treeData,
      iconModal,
      formState,
      roleformRef,
      modalConfig,
      meneOptions,
      replacekey,
      userSelectMenu,
      permissionButton,
      addPerssionById,
      addMenuById,
      toEdit,
      toDelete,
      handleOk,
      iconClose,
      iconSelect,
      selectMenu,
      removeIcon,
      saveConfig,
      handleClose,
      toChooseIcon,
      checkMenuChild,
      selectRoleTree,
      toDeletePerssion,
      selectAuthority,
      checkSuperior,
      selectUser,
      filterMenuRef,
      isDevelopment,
      handleUpdateMenu,
    };
  },
});
